const colorVitalSigns = {
  
    //  Not a chapter, default black!
    defaultColor: '#000000',
    //  Temperature colors.
    hypothermiaColor: '#15B1EB',
    lowGradeFeverColor: '#EBB115',
    feverColor: '#EB2900',
    //   Heart rate.
    bradycardiaColor: '#15B1EB',
    tachycardiaColor: '#EB2900',
    //  Blood pressure systolic & diastolic
    hypotensionColor: '#15B1EB',
    preHypertensionColor: '#EBB115',
    hypertensionColor: '#EB2900',
    //  Oxygen
    hypoxiaColor: '#15B1EB',
  };
  
  export default colorVitalSigns;